/* eslint-disable no-console */
import React, {useEffect, useState} from 'react'
import {useForm} from 'react-hook-form'
// import {toast} from 'react-toastify'
import {Button} from 'helpers/ui-components/Button'
import {useTranslation} from 'react-i18next'
import {
 fetchChildOnboardingItmesConfig,
 updateOnboardingItmes,
} from 'utils/api/auth/myAccountService'
import {IItmeConfig, IItmesConfig} from 'models/GenericForm'
import GenericFormBuilder from 'helpers/ui-components/GenericFormBuilder'
import {
 IFileObject,
 IFormData,
 IFormField,
} from 'models/Common'
import {toast} from 'react-toastify'
// import {ILogin} from 'models/Auth'

type IProps = {
 userId: string
 parentItemConfig?: IItmesConfig
 toggleBtnIconList?: IFormField
 isDisabled: boolean
 loader: boolean
 className: string
 formBuilderClassName?: string
 setIsDisabled: (newState: boolean) => void
 setLoader: (newState: boolean) => void
 reloadTabs: () => void
}

const OnBoardingFormComponent = (props: IProps) => {
 const {t} = useTranslation()
 const [uploadedFileData, setUploadedFileData] =
  useState<IFileObject>({})
 const [itemConfigList, setItemConfigList] = useState<
  IItmesConfig[]
 >([])
 const [onBoardingItemList, setOnBoardingItemList] =
  useState<IItmesConfig[]>([])
 const userId = props.userId
 console.log('userId', userId)
 const form = {
  country: 'ind',
 }
 const {
  register,
  control,
  getValues,
  watch,
  setValue,
  handleSubmit,
  formState: {errors},
 } = useForm({
  mode: 'all',
  reValidateMode: 'onChange',
  defaultValues: {...form},
 })

 const getOnboardingItmesConfig = async (
  parentId: number,
  configItemsList: IItmesConfig[]
 ) => {
  const childConfigList: IItmesConfig[] = []
  const res: IItmesConfig[] =
   await fetchChildOnboardingItmesConfig(parentId, userId)
  if (res) {
   for (const child of res) {
    if (child.onboarding_item_type === 'COMPOSITE') {
     const childConfigRes: IItmesConfig[] | undefined =
      await getOnboardingItmesConfig(
       child.id,
       configItemsList
      )
     if (childConfigRes) {
      child.childData = [...childConfigRes]
     }
    } else {
     configItemsList.push(child)
    }
    childConfigList.push(child)
   }
  }
  return childConfigList
 }

 const setOnboardingItmes = async () => {
  if (props.parentItemConfig) {
   setItemConfigList([])
   setOnBoardingItemList([])
   props.setLoader(true)
   const configItemsList: IItmesConfig[] = []
   const childRes: IItmesConfig[] | undefined =
    await getOnboardingItmesConfig(
     props.parentItemConfig.id,
     configItemsList
    )
   setOnBoardingItemList(configItemsList)
   console.log('childRes', childRes)
   setItemConfigList(childRes)
   props.setLoader(false)
  }
 }

 async function submitFormData(formData: IFormData) {
  props.setLoader(true)
  const onBoardingItems: IItmeConfig[] = []
  for (const data of onBoardingItemList) {
   const fields: IFormData = {}
   for (const field of data.fields) {
    let value
    const labelKey = field.label_key
    if (field.field_type === 'TOGGLE_FIELD') {
     value = formData?.[labelKey]?.toString()
    } else if (field.field_type === 'IMAGE_FIELD') {
     value = uploadedFileData?.[labelKey]?.filePath
    } else if (field.field_type === 'FILE_FIELD') {
     value = uploadedFileData?.[labelKey]?.filePath
    } else {
     value = formData?.[labelKey]
    }

    fields[labelKey] = value
   }

   onBoardingItems.push({
    id: data.id,
    user_category: data.user_category,
    item_identifier: data.item_identifier,
    fields,
   })
  }
  const res = await updateOnboardingItmes({
   ...(props.userId && {user_id: props.userId}),
   onboarding_items: onBoardingItems,
  })
  if (res) {
   toast.success(res)
  }
  props.reloadTabs()
  props.setIsDisabled(true)
  props.setLoader(false)
 }

 const renderOnboardingItmesConfig = (
  data: IItmesConfig,
  isChild: boolean
 ) => {
  return (
   <div key={data.id} className={`w-full mt-4`}>
    {isChild && (
     <div className='text-[#33393D] text-base font-semibold'>
      {data.name}
     </div>
    )}
    {data?.childData &&
     data?.childData?.length > 0 &&
     data?.childData.map((childNode: IItmesConfig) =>
      renderOnboardingItmesConfig(childNode, true)
     )}
    <div className={`${props.className}`}>
     <GenericFormBuilder
      isDisabled={props.isDisabled}
      itemConfigList={[{...data}]}
      excludedFields={[]}
      parentId={data?.id}
      uploadedFileData={uploadedFileData}
      setUploadedFileData={setUploadedFileData}
      setLoader={props.setLoader}
      register={register}
      control={control}
      getValues={getValues}
      errors={errors}
      watch={watch}
      setValue={setValue}
      toggleBtnIconList={props?.toggleBtnIconList}
      className={props?.formBuilderClassName}
     />
    </div>
   </div>
  )
 }

 useEffect(() => {
  if (props.parentItemConfig) {
   void setOnboardingItmes()
  }
 }, [props.parentItemConfig])

 return (
  <div className='w-full'>
   <form
    method='POST'
    action=''
    onSubmit={handleSubmit(submitFormData)}
   >
    {!props.isDisabled && itemConfigList.length > 0 && (
     <div className='w-full mb-6 flex justify-end'>
      <div className='flex items-center '>
       <Button
        type='submit'
        color='blue'
        className='text-center py-[9px] px-6 bg-[#4E83E4] 
                  !rounded-lg text-base text-white font-semibold border-[#4E83E4]'
       >
        {t('myAccountPage.save')}
       </Button>
      </div>
     </div>
    )}
    <div className='w-full'>
     {itemConfigList?.map(
      (val: IItmesConfig, i: number) => (
       <div key={i} className={`w-full mb-10`}>
        <div className='text-[#2F2F2F] text-2xl font-medium'>
         {val.name}
        </div>
        {renderOnboardingItmesConfig(val, false)}
       </div>
      )
     )}
    </div>
   </form>
  </div>
 )
}

export default OnBoardingFormComponent
